/** @deprecated */
export enum GACategory {
  PRODUCT_EMBED = 'Embed Clicks',
  EDITOR = 'editor',
  CONVERSION = 'conversion',
  MARKETPLACE = 'Marketplace',
  SEARCH = 'Search',
  BEHAVIOR = 'behavior',
  WEBAPP = 'webapp',
  VIEWER = 'NF Viewer',
  SITE_CREATION = 'Site creation',
  RTHREE = 'r3',
}
